// 如果用户访问一个未定义的路由，会去到一个空白页
// 检查当前路由是否未定义，未定义则去首页
export default ({ redirect, $log, app: { router } }) => {
  router.beforeEach((to, from, next) => {
    if (!to.name) {
      $log &&
        $log.error('router error', {
          msg: `to: ${to?.fullPath}, from: ${from?.fullPath}`
        });
      redirect('/');
    } else {
      next();
    }
  });
};
